import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { AppBreadcrumb } from './AppBreadcrumb';

const DECK_LAYOUT_CLASS = 'flex flex-col gap-page-gap';
const TOOLBAR_ROW_CLASS =
  'mb-toolbar-gap-offset flex flex-col gap-2 sm:flex-row sm:flex-wrap sm:items-center';

interface PageToolbarProps {
  currentTitle: ReactNode;
  breadcrumbAddon?: ReactNode;
  children?: ReactNode;
  panel?: ReactNode;
  className?: string | undefined;
}

export function PageToolbar({
  currentTitle,
  breadcrumbAddon,
  children,
  panel,
  className,
}: PageToolbarProps) {
  return (
    <div className={cn(DECK_LAYOUT_CLASS, className)}>
      <div className={TOOLBAR_ROW_CLASS}>
        <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1.5">
          <AppBreadcrumb currentTitle={currentTitle} />
          {breadcrumbAddon}
        </div>
        {children ? (
          <div className="flex min-w-0 flex-wrap items-center gap-2 sm:ml-auto sm:justify-end">
            {children}
          </div>
        ) : null}
      </div>
      {panel}
    </div>
  );
}
